export const LOCATION_SETTINGS = {
  GENERAL: 'general',
  ORDERING: 'ordering-settings',
  CATERING: 'catering-settings',
  DELIVERY: 'delivery-settings',
};
